import type { B2gContract as B2gContractData } from '@mathflat/domain/Academy'
import { computed, makeObservable, observable } from 'mobx'

import { typeSafeAssign } from '@/utils/common'

import { DTO } from '../DTO'

export class B2gContract extends DTO {
  academyId: B2gContractData['academyId'] | null = null
  schoolName: B2gContractData['schoolName'] | null = null
  status: B2gContractData['status'] | null = null
  amount: B2gContractData['amount'] = 0
  contractStartDateTime: B2gContractData['contractStartDateTime'] | null = null
  contractEndDateTime: B2gContractData['contractEndDateTime'] | null = null
  subscribePlan: B2gContractData['subscribePlan'] | null = null
  studentCount: B2gContractData['studentCount'] = 0
  pdfUrl: B2gContractData['pdfUrl'] = null

  constructor(data?: B2gContractData) {
    super()
    makeObservable(this, {
      academyId: observable,
      status: observable,
      amount: observable,
      schoolName: observable,
      contractStartDateTime: observable,
      contractEndDateTime: observable,
      subscribePlan: observable,
      studentCount: observable,
      pdfUrl: observable,
      isUnSigned: computed,
    })

    if (data) typeSafeAssign(this, data)
  }
  get isUnSigned() {
    return this.status !== 'SIGNED'
  }
}
